export const trace = import.meta.env.DEV
    ? // biome-ignore lint/suspicious/noExplicitAny: trace forwards arbitrary console.log args
      (...args: any) => console.log('[src/index]', ...args)
    : () => {};
